// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_1MdbX clearfix","box":"index_box_cr8qN"};